import { FC } from 'react';
import clsx from 'clsx';
import './AISparklesAnimated.scss';

export interface IAISparklesAnimatedProps {
    /** Сторона квадрата в px (по умолчанию 30) */
    size?: number;
    className?: string;
}

const GRADIENT_ID = 'ai-sparkles-animated-gradient';

const AISparklesAnimated: FC<IAISparklesAnimatedProps> = ({ size = 30, className }) => (
    <svg
        className={clsx('ai-sparkles-animated', className)}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
    >
        <defs>
            <linearGradient id={GRADIENT_ID} x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#ff0067" />
                <stop offset="50%" stopColor="#8a3ffc" />
                <stop offset="100%" stopColor="#1f5bff" />
            </linearGradient>
        </defs>
        <g fill={`url(#${GRADIENT_ID})`}>
            <path
                className="ai-sparkles-animated__spark ai-sparkles-animated__spark--main"
                d="M16 6.5 17.6 14.4 25.5 16 17.6 17.6 16 25.5 14.4 17.6 6.5 16 14.4 14.4Z"
            />
            <path
                className="ai-sparkles-animated__spark ai-sparkles-animated__spark--top"
                d="M7 2 7.7 5.3 11 6 7.7 6.7 7 10 6.3 6.7 3 6 6.3 5.3Z"
            />
            <path
                className="ai-sparkles-animated__spark ai-sparkles-animated__spark--bottom"
                d="M25 22 25.5 24.5 28 25 25.5 25.5 25 28 24.5 25.5 22 25 24.5 24.5Z"
            />
        </g>
    </svg>
);

export default AISparklesAnimated;
